import { FunctionComponent } from 'react';
import { Flex, Center, Heading, Text, Image, Button } from '@chakra-ui/react';

type BasicSlideProps = {
    imageSource?: string;
    title: string;
    description: string;
    buttonText?: string;
    onClick?: () => void;
    layoutType: 'normal' | 'inverted';
};

const BasicSlide: FunctionComponent<BasicSlideProps> = ({
    imageSource,
    description,
    title,
    children,
    buttonText,
    onClick,
    layoutType,
}) => {
    const image = imageSource && (
        <Image boxSize='200px' objectFit='cover' src={imageSource} alt='' />
    );

    return (
        <Flex direction='column'>
            <Center pt={2}>
                {layoutType === 'normal' && image}
                {layoutType === 'normal' && !imageSource && children}
                {layoutType === 'inverted' && (
                    <Heading textAlign='center'>{title}</Heading>
                )}
            </Center>
            <Center pt={8}>
                {layoutType === 'normal' && (
                    <Heading textAlign='center'>{title}</Heading>
                )}

                {layoutType === 'inverted' && image}
                {layoutType === 'inverted' && !imageSource && children}
            </Center>
            <Center pt={8}>
                <Text align='center'>{description}</Text>
            </Center>
            {buttonText && onClick && (
                <Center pt={10}>
                    <Button onClick={onClick}>{buttonText}</Button>
                </Center>
            )}
        </Flex>
    );
};

export default BasicSlide;
